import { useState, useEffect } from "react";
import { fetchSheetData } from "./fetchSheetData";

export const useGigData = (sheetId) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSheetData(sheetId, "Gigs!A1:Z100");
        setData(data);
      } catch (e) {
        console.error("Error fetching gigs", e.message);
      }
    };
    fetchData();
  }, [sheetId]);

  return data;
};
